module.exports = __webpack_public_path__ + "static/img/logo45.be59ab5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo45.png
// module id = wN9D
// module chunks = 1